export default class CrearPerfilCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(payload) {
    try {
      const result = await this.#repository.crearPerfilCurso(payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
